import React from 'react';

import { IntlShape } from 'react-intl';

import { ServiceMode } from 'state/order';

interface IGetOrderConfirmationHeader {
  userName: string;
  needConfirm: boolean | undefined;
  formatMessage: IntlShape['formatMessage'];
}

interface IGetOrderConfirmationInstructions {
  userName: string;
  serviceMode: ServiceMode;
  needConfirm: boolean | undefined;
  formatMessage: IntlShape['formatMessage'];
  imHere: React.ReactNode;
  isMobileOrderForDriveThruLaneEnabled: boolean;
  isOrderBayEnabled: boolean;
}

export const getOrderConfirmationHeader = ({
  userName,
  needConfirm,
  formatMessage,
}: IGetOrderConfirmationHeader): string => {
  const key = needConfirm ? 'orderHasBeenSaved' : 'orderIsBeingMadeYourWay';
  return formatMessage({ id: key }, { userName });
};

export const getOrderConfirmationInstructions = ({
  userName,
  serviceMode,
  needConfirm,
  formatMessage,
  imHere,
  isMobileOrderForDriveThruLaneEnabled,
  isOrderBayEnabled,
}: IGetOrderConfirmationInstructions): string | React.ReactNode | null => {
  let instructions;

  switch (serviceMode) {
    case ServiceMode.EAT_IN:
      instructions = needConfirm
        ? 'orderConfirmationInstructionsPreConfirmed'
        : 'orderConfirmationInstructionsConfirmed';
      break;
    case ServiceMode.TAKEOUT:
      instructions = needConfirm
        ? 'orderConfirmationInstructionsPreConfirmed'
        : 'orderConfirmationInstructionsTakeOut';
      break;
    case ServiceMode.DELIVERY:
      instructions = 'orderConfirmationInstructionsDelivery';
      break;
    case ServiceMode.CURBSIDE:
      // TODO: BKPE-6812 ORDER_BAY_PILOT. Remove or consolidate this logic once the pilot is done
      if (isOrderBayEnabled) {
        instructions = 'orderConfirmationInstructionsConfirmedOrderBay';
      } else {
        instructions = needConfirm
          ? 'orderConfirmationInstructionsPreConfirmed'
          : 'orderConfirmationInstructionsConfirmedCurbside';
      }
      break;
    case ServiceMode.DRIVE_THRU:
      instructions = isMobileOrderForDriveThruLaneEnabled
        ? 'orderConfirmationInstructionsMobileDriveThru'
        : 'orderConfirmationInstructionsDriveThru';
      break;
    case ServiceMode.MOBILE_ORDER_DRIVE_THRU:
      instructions = 'orderConfirmationInstructionsMobileDriveThru';
      break;
    default:
      instructions = '';
  }

  return instructions ? formatMessage({ id: instructions }, { userName, imHere }) : null;
};
